import React from "react";
import { MdClose } from "react-icons/md"; // importando o ícone
import styles from "./styles.module.css";

const Modal = ({ isOpen, onClose, titulo, children }) => {
  return (
    <>
      {isOpen && (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            <button className={styles.closeButton} onClick={onClose}>
              <MdClose />
            </button>
            <h2 className="titulo">{titulo}</h2>
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
